import React, { useEffect, useState } from 'react';
import { Link, } from 'react-router-dom';
import '../../App.css'
import {
  Offcanvas,
  Ripple,
  Dropdown,
  initTE,
} from "tw-elements";
import { FaBars, FaTimes } from 'react-icons/fa';

const Navbar = () => {
  initTE({ Offcanvas, Ripple, Dropdown });

  const [active, setActive] = useState(null)
  const [open, setOpen] = useState(false)


  const scrollToSection = (sectionId) => {
    const targetSection = document.getElementById(sectionId);
    setActive(sectionId)

    const menu = document.querySelector(".mobile-menu");
    menu.classList.remove("scale-y-100");
    
    setOpen(false)
    
    if (targetSection) {
      targetSection.scrollIntoView({ behavior: 'smooth' });
      setActive(sectionId)

    }
    
  };


  useEffect(() => {
    // Function to check if a section is in the viewport
    const isSectionInView = (sectionId) => {
      const section = document.getElementById(sectionId);
      if (section) {
        const rect = section.getBoundingClientRect();
        const sectionInnerHeight = section.clientHeight;
        return rect.top <= sectionInnerHeight * 0.5 && rect.bottom >= 0;  // Adjust the threshold as needed
      }
      return false;

    };

    /// Debounce function to limit the frequency of handleScroll calls
    const debounce = (func, delay) => {
      let timeoutId;
      return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          func(...args);
        }, delay);
      };
    };

    // Debounce handleScroll with a delay of 100ms (adjust as needed)
    const debouncedHandleScroll = debounce(() => {
      let activeSection = null;
      for (const section of navItems) {
        if (isSectionInView(section.target)) {
          activeSection = section.target;
        }
      }
      setActive(activeSection);
    }, 150);

    // Add the debounced handler to the scroll event
    window.addEventListener('scroll', debouncedHandleScroll);


    // Attach the scroll event listener
    window.addEventListener("scroll", debouncedHandleScroll);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("scroll", debouncedHandleScroll);
    };
  }, []); // Empty 

  const navItems = [
    {
      path: '/#home',
      target: '#home',
      item: "Home"
    },
    {
      path: '/#about',
      target: '#about',
      item: "About"
    },
    {
      path: '/#skill',
      target: '#skill',
      item: "Skills"
    },
    {
      path: '/#projects',
      target: '#projects',
      item: "Projects"
    },
    {
      path: '/#contact',
      target: '#contact',
      item: "Contact"
    }

  ]


  const toggleIcons = () => {
    // grab everything we need
    setOpen(!open)


    const menu = document.querySelector(".mobile-menu");

    // add event listeners

    menu.classList.toggle("scale-y-100");

  }


  return (
    <div>
      <div class=" " >

        {/* <!-- navbar goes here --> */}
        <nav class=" fixed border-b border-gray-700 z-10 top-0 glass-bg inset-x-0">
          <div class="  mx-auto px-4 md:px-10 lg:px-20  content max-w-[1500px] ">
            <div class="flex justify-between ">


              {/* <!-- mobile button goes here --> */}
              <div class="md:hidden flex items-center">

                <button onClick={toggleIcons} class="mobile-menu-button transition-all ml-1 rounded-sm p-1 bg-gradient-to-r from-[#4E10FF] to-[#AB17DF] text-white duration-300" >

                  {
                    open ? <FaTimes className='w-5 h-5' /> : <FaBars className='w-5 h-5' />
                  }

                </button>
              </div>

              {/* <!-- logo --> */}
              <div>
                <a href=" " class="flex items-center py-5 px-2 text-gray-100 hover:text-gray-300">

                  <span class="font-bold text-2xl">Bappy</span>
                </a>
              </div>
              {/* <!-- primary nav --> */}
              <div class="hidden md:flex items-center space-x-1 font-semibold text-lg">

                {
                  navItems?.map((nav, e) =>

                    <Link
                      key={e.target}
                      onClick={() => scrollToSection(`${nav.target}`)}
                      className={`py-2 px-3 font-semibold text-gray-100 duration-300 ease-in-out transition-all hover:text-[#ab17df] ${active === nav.target ? 'text-[#ab17df]' : ''
                        }`}
                      to={nav.path}
                    >
                      <span
                        className={`hover:border-b-[3px] hover:transition-all  border-indigo-500 hover:text-[#ab17df] ${active === nav.target ? 'border-b-[3px] border-indigo-600 text-indigo-600' : ''
                          }`}
                      >
                        {nav.item}
                      </span>
                    </Link>

                  )
                }
              </div>




              <div class="hidden md:flex text-white items-center space-x-1">
                <a
                  data-te-ripple-init
                  data-te-ripple-color="light"
                  href="https://drive.google.com/file/d/1gn29CRzzBaI1PXyhcKVl3yYrmoPQxtlu/view?usp=drive_link" target='_blank '>
                  <button className="px-5 py-1 animate-btn rounded-[4px]  bg-gradient-to-r from-[#4E10FF] to-[#AB17DF] text-lg font-semibold  " >
                    Resume
                  </button>
                </a>
              </div>


            </div>

          </div>

          {/* <!-- mobile menu --> */}


          <div class="mobile-menu     text-left  transform scale-y-0 origin-top   absolute top-full left-0 w-full      justify-center items-start    md:relative md:scale-y-100 md:transition-all duration-500     md:hidden bg-[#0c0324] transition-all  ">

            {
              navItems?.map((nav, e) =>

                <Link
                  key={e.target}
                  onClick={() => scrollToSection(`${nav.target}`)}
                  className={`py-3  border-t hover:bg-gradient-to-r from-[#4E10FF] to-[#AB17DF] border-gray-700 block px-6 font-semibold text-white duration-300 ease-in-out transition-all hover:text-white ${active === nav.target ? 'bg-gradient-to-r from-[#4E10FF] to-[#AB17DF] ' : ''
                    }`}
                  to={nav.path}
                >
                  <span
                    className={` :transition-all  border-indigo-500   ${active === nav.target ? '  ' : ''}`}
                  >
                    {nav.item}
                  </span>
                </Link>

              )
            }

            <a className='py-3 px-6 block border-y border-gray-600  hover:bg-gradient-to-r from-[#4E10FF] to-[#AB17DF] font-semibold text-gray-100' href="https://drive.google.com/file/d/1gn29CRzzBaI1PXyhcKVl3yYrmoPQxtlu/view?usp=drive_link" target='_blank '>Resume</a>
          </div>

        </nav>
      </div>
    </div>
  );
};

export default Navbar;